import HelpIcon from '@mui/icons-material/Help'
import { IconButton } from '@mui/material'
import { useRootLoaderData } from 'components/Root.loader'
import { VITE_BASE_DOC_URL } from 'config'

export type ReaderHelpIconProps = {
  text?: string
  builderPath: string
  concurPath: string
  invoicePath: string
  orderFormPath: string
}
const TARGET = '_blank'

export default function ReaderHelpIcon({
  text,
  builderPath,
  concurPath,
  invoicePath,
  orderFormPath,
}: ReaderHelpIconProps) {
  const rootData = useRootLoaderData()
  const { useInvoiceOCR, useConcur, useOCRBuilder, useOrderForm } = rootData.userGroupConfig

  let helpUrl = ''
  if (useOCRBuilder && builderPath) {
    helpUrl = VITE_BASE_DOC_URL + builderPath
  } else if (useConcur && concurPath) {
    helpUrl = VITE_BASE_DOC_URL + concurPath
  } else if (useInvoiceOCR && invoicePath) {
    helpUrl = VITE_BASE_DOC_URL + invoicePath
  } else if (useOrderForm && orderFormPath) {
    helpUrl = VITE_BASE_DOC_URL + orderFormPath
  }

  return (
    <>
      {helpUrl && text ? (
        <a target={TARGET} href={helpUrl}>
          {text}
        </a>
      ) : (
        <IconButton component="a" target={TARGET} href={helpUrl} data-testid="help-icon">
          <HelpIcon style={{ color: 'grey' }} />
        </IconButton>
      )}
    </>
  )
}
